module.exports = __webpack_public_path__ + "img/case2.2e33f95a.jpg";